import {InvDetailType} from "../interface";
import {useDeleteInvSingle} from "../hooks/useDeleteInvSingle";
import useGoToNavigation from "../../../../../util/useGotoNavigation";
import {useModal} from "../../../../../hooks";
import {useParams} from "react-router-dom";
import AuthorityChecker from "../../../../../components/common/authorityGuard/AuthorityChecker";

interface PropsType {
    invDetail: InvDetailType
}

export default function Upper({invDetail}: PropsType) {
    const {id} = useParams()
    const {goToNavigation} = useGoToNavigation()
    const {handleModal} = useModal();

    const {mutate: mutateDeleteInvSingle} = useDeleteInvSingle()

    const btnGoToBarcode = () => {
        goToNavigation(`inventory/barcode?i=${invDetail.inventoryId}`, {}, false)
    }

    const btnDelete = () => {
        handleModal({
            isOpen: true,
            contents: "삭제하시겠습니까?",
            type: "confirm",
            callback: () => mutateDeleteInvSingle({inventoryId: Number(id as string)})
        });
    }

    return <div className="content_wrap">
        <div className="fiter_top">
            <h3 className="filter_heading">재고 상세보기</h3>
            <div className="filter_toolbar">
                <button
                    className="btn btn-outline-primary w-100px h-38px ms-40px"
                    onClick={() => {
                        goToNavigation("inventory/inv/list", {}, false)
                    }}
                >
                    <img
                        src={
                            process.env.PUBLIC_URL +
                            "/assets/images/icon_hamburger_btn.png"
                        }
                        alt=""
                    />
                    목록
                </button>
                <button className="btn btn-primary" onClick={btnGoToBarcode}>바코드 인쇄</button>
                <AuthorityChecker authorityNames={['inventoryWriteYn']}>
                    <button className="btn btn-outline-dark" onClick={btnDelete}><img
                        src={process.env.PUBLIC_URL + "/assets/images/icon_cross.png"} alt=""/>삭제
                    </button>
                </AuthorityChecker>
            </div>
        </div>

        <h5 className="subheading">제품정보</h5>
        <table className="table table-bordered my_table table_detail">
            <tbody>
            <tr>
                <th style={{width: "16.66%"}}>품목명</th>
                <td colSpan={3}>{invDetail.newTxtNmItem} &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    {invDetail.newTxtStndItem} / {invDetail.inventoryUnit}EA
                </td>
            </tr>
            <tr>
                <th>생성일자</th>
                <td>{invDetail.createdon}</td>
                <th style={{width: "16.66%"}}>생성자</th>
                <td>{invDetail.nameOfCreator}</td>
            </tr>
            </tbody>
        </table>
    </div>
}